<template>
    <div class="sportsbook">
        <form class="main-form" @submit.prevent="search">
            <custom-input 
                v-model="ticketID"
                @clear="ticketID"
                :title="$t('SPORTSBOOK_PAYOUTS__TICKET_ID')"
            />
            <button class="btn">{{ $t('SPORTSBOOK_PAYOUTS__SEARCH') }}</button>
        </form>
        <iframe :src="src" v-show="src"></iframe>
        <custom-snackbar
            :text="message.text"
            :purpose="message.purpose"
            v-if="message.visible"
            @close="message.visible = false"
        />
        <overlay :visible="popupVisible" @close="popupVisible = false">
            <popup @close="popupVisible = false" :title="$t('SPORTSBOOK_PAYOUTS__CREATE_SPORTSBOOK_USER_ACCOUNT_CARD')">
                <form class="main-form" @submit.prevent="create">
                    <custom-input 
                        v-model="createForm.userName"
                        @clear="createForm.userName = ''"
                        :title="$t('SPORTSBOOK_PAYOUTS__USERNAME')"
                    />
                    <custom-input 
                        v-model="createForm.balance"
                        @clear="createForm.balance = ''"
                        inputType="number"
                        :title="$t('SPORTSBOOK_PAYOUTS__BALANCE')"
                    />
                    <custom-input 
                        v-model="createForm.password"
                        @clear="createForm.password = ''"
                        inputType="password"
                        :title="$t('SPORTSBOOK_PAYOUTS__PASSWORD')"
                    />
                    <button class="btn">{{ $t('SPORTSBOOK_PAYOUTS__CREATE') }}</button>
                </form>
            </popup>
        </overlay>
    </div>
</template>

<script>
import axios from '@/Helpers/AxiosInstance.js'
import Popup from '@/components/ReusableComponents/Popup/Popup.vue'
import Overlay from '@/components/ReusableComponents/Overlay/Overlay.vue'
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import CustomSnackbar from '@/components/ReusableComponents/CustomSnackbar/CustomSnackbar.vue'
export default {
    components: {
        CustomSnackbar, Popup, Overlay, CustomInput,
    },
    created() {
        axios
            .get('WebShop/GetSportsBookTicketUserAccountCard')
            .then(resp => {
                if(resp.data.response) {
                    this.userName = resp.data.response.userName
                    this.search()
                }
                else {
                    this.popupVisible = true
                }
            })
    },
    data() {
        return {
            message: {
                text: 'Cannot Load The Sportsbook!',
                purpose: 'error',
                visible: false,
            },
            src: '',
            userName: '',
            popupVisible: false,
            createForm: {
                userName: '',
                balance: '0',
                password: '',
            },
            ticketID: '',
        }
    },
    methods: {
        search() {
            axios
                .get('WebShop/GetSportsBookJWTToken', {
                    params: {
                        userName: this.userName,
                    },
                })
                .then(resp => {
                    if(resp.data.token.status == 1) {
                        this.loadIFrame(resp)
                    }
                    else this.src = ''
                })
                .catch(() => {
                    this.message.visible = true
                })
        },
        loadIFrame(resp) {
            let token = resp.data.token.response
            this.src = `https://sport.inplaynet.tech/admin/html/iframe_tickets.html?jwttoken=${token}&ticket=${this.ticketID}&filters=0&showpayout=true`
        },
        create() {
            axios
                .post('WebShop/CreateSportsBookUserAccountCard', {
                    UserName: this.createForm.userName,
                    Balance: this.createForm.balance,
                    Password: this.createForm.password,
                })
                .then(resp => {
                    if(resp.data.status != 1) return
                    this.userName = resp.data.response.userName
                    this.popupVisible = false
                    this.search()
                })
        }
    },
}
</script>

<style scoped lang="scss">
form {
    margin-bottom: 15 * $rem;
}

iframe {
    width: 100%;
    height: calc(100vh - #{151 * $rem});
}

/deep/ label {
    margin-right: 15 * $rem;
}
</style>
